import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import type { RoleType } from '../../types';

interface AssignmentItemDisplayProps {
  name: string;
  email?: string;
  isTarget: boolean;
  roleType?: RoleType;
  roleOptions: Array<{ label: string; value: RoleType }>;
  onRoleChange?: (newRole: RoleType) => void;
  rolePlaceholder: string;
}

export function AssignmentItemDisplay({
  name,
  email,
  isTarget,
  roleType,
  roleOptions,
  onRoleChange,
  rolePlaceholder,
}: AssignmentItemDisplayProps) {
  return (
    <div className="access-manager-list-item">
      <div className="access-manager-list-item-content">
        <div className="access-manager-list-item-name">{name}</div>
        {email && <div className="access-manager-list-item-email">{email}</div>}
      </div>
      {isTarget && roleType && onRoleChange && (
        <Dropdown
          value={roleType}
          options={roleOptions}
          onChange={(e: DropdownChangeEvent) => {
            onRoleChange(e.value);
          }}
          placeholder={rolePlaceholder}
          className="access-manager-role-dropdown"
        />
      )}
    </div>
  );
}
